import storageService from "lib/utils/localStorage/storageService";

export { getPipelineLocalStorageData } from "lib/utils/localStorage/getPipelineLocalStorageData";
export { storageService };
